import { render, staticRenderFns } from "./OwnershipBankForm.vue?vue&type=template&id=030b8880&scoped=true&"
import script from "./OwnershipBankForm.vue?vue&type=script&lang=js&"
export * from "./OwnershipBankForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnershipBankForm.vue?vue&type=style&index=0&id=030b8880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b8880",
  null
  
)

export default component.exports